export default "__VITE_ASSET__4lrlVQeS__"